import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { rootLoader } from '@/api/loaders';
import App from '@/App';
import GoogleTranslateErrorBoundary from '@/components/ErrorBoundary/GoogleTranslateErrorBoundary';

import { ROUTES } from './paths';

const Amount = lazy(() => import('@pages/Amount/Amount'));
const Payment = lazy(() => import('@pages/Payment/Payment.index'));
const Products = lazy(() => import('@pages/Products/Products.index'));
const ProcessPayment = lazy(() => import('@pages/Process/ProcessPayment'));
const Success = lazy(() => import('@pages/Response/Success'));
const Response = lazy(() => import('@pages/Response/Response'));
const Static = lazy(() => import('@pages/StaticPayment/Static'));

export const merchantRoutes: RouteObject = {  
  path: ROUTES.MERCHANT,
  element: (
    <GoogleTranslateErrorBoundary>
      <App />
    </GoogleTranslateErrorBoundary>
  ),
  id: 'root',
  loader: rootLoader,
  children: [
    {
      path: ROUTES.AMOUNT,
      element: (
        <GoogleTranslateErrorBoundary>
          <Amount />
        </GoogleTranslateErrorBoundary>
      ),
      index: true,
    },
    {
      path: ROUTES.PAYMENT.AMOUNT,
      element: (
        <GoogleTranslateErrorBoundary>
          <Payment />
        </GoogleTranslateErrorBoundary>
      ),
    },
    {
      path: ROUTES.PAYMENT.STATIC,
      element: (
        <GoogleTranslateErrorBoundary>
          <Payment />
        </GoogleTranslateErrorBoundary>
      ),
    },
    {
      path: ROUTES.PRODUCTS.LIST,
      element: (
        <GoogleTranslateErrorBoundary>
          <Products />
        </GoogleTranslateErrorBoundary>
      ),
    },
    {
      path: ROUTES.PRODUCTS.DETAIL,
      element: (
        <GoogleTranslateErrorBoundary>
          <Payment />
        </GoogleTranslateErrorBoundary>
      ),
    },
    {
      path: ROUTES.PAYMENT.PROCESS,
      element: (
        <GoogleTranslateErrorBoundary>
          <ProcessPayment />
        </GoogleTranslateErrorBoundary>
      ),
    },
    {
      path: ROUTES.PAYMENT.SUCCESS,
      element: (
        <GoogleTranslateErrorBoundary>
          <Success />
        </GoogleTranslateErrorBoundary>
      ),
    },
    {
      path: ROUTES.PAYMENT.RESPONSE,
      element: (
        <GoogleTranslateErrorBoundary>
          <Response />
        </GoogleTranslateErrorBoundary>
      ),
    },
    {
      path: ROUTES.STATIC,
      element: (
        <GoogleTranslateErrorBoundary>
          <Static />
        </GoogleTranslateErrorBoundary>
      ),
    }
  ]
}; 